import React from "react";
import { withRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";

import GenericError from "./GenericError";

export class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		console.log(error, errorInfo);

		Sentry.captureException(new Error(error), {
			extra: {
				errorInfo: errorInfo,
			},
		});
	}

	onGoBackClick() {
		this.setState({
			hasError: false,
		});
	}

	render() {
		const { error, hasError } = this.state;

		if (hasError) {
			if (error.name === "ChunkLoadError") {
				window.location.reload(); // happens after a new deployment, force a refresh of the page
				return <></>;
			}
			return (
				<>
					<GenericError onGoBackClick={this.onGoBackClick.bind(this)}></GenericError>
				</>
			);
		}

		return this.props.children;
	}
}

export default withRouter(ErrorBoundary);
